import { IAssigneeCompletedInfo, ICollection, ITask } from '@/bundles/Tasks/interfaces/ITask';
import { TaskTypesEnum } from '@/bundles/Tasks/enums/TaskTypesEnum';
import { BaseArangoModel } from '@/bundles/App/models/BaseArangoModel';

export class Task extends BaseArangoModel implements ITask {
  title: string;
  type: TaskTypesEnum;
  assignee: number;
  due_date: Date; // Date in local timezone
  description: string;
  schedule?: string; // rrule expression
  collaborators: number[];
  team_ids: number[];
  status: string;
  collections: ICollection[];
  marketing: boolean;
  priority: number;
  assignee_info?: IAssigneeCompletedInfo;
  completed_by?: IAssigneeCompletedInfo;
  recurrent_group_id?: string; // ID to group recurrent tasks

  constructor (payload: ITask) {
    super(payload);
    this.title = payload.title;
    this.type = payload.type;
    this.assignee = payload.assignee;
    this.due_date = new Date(payload.due_date);
    this.description = payload.description;
    this.status = payload.status;
    this.marketing = payload.marketing;
    this.priority = payload.priority;

    if (payload.schedule) {
      this.schedule = payload.schedule;
    }

    this.collections = payload.collections || [];
    this.collaborators = payload.collaborators || [];
    this.team_ids = payload.team_ids || [];

    if (payload.assignee_info) {
      this.assignee_info = payload.assignee_info;
    }

    if (payload.completed_by) {
      this.completed_by = payload.completed_by;
    }

    if (payload.recurrent_group_id) {
      this.recurrent_group_id = payload.recurrent_group_id;
    }
  }
}
